import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// MENU REVEAL
export class MenuReveal {
  constructor(selector = ".main-menu li") {
    this.timeline = gsap.timeline();
    this.selector = selector;

    gsap.set(this.selector, {
      autoAlpha: 0,
      translateX: "-10px"
    });
  }

  reveal() {
    this.timeline.to(this.selector, {
      autoAlpha: 1,
      translateX: "0px",
      stagger: 0.15,
    });
  };

  reset() {
    this.timeline.progress(1);

    gsap.set(this.selector, {
      autoAlpha: 0,
      translateX: "-10px"
    });
  };

}

// TEXTS ANIMATIONS
export function maskFromBottom(userOptions) {
  let options = {
    wrapper: '.masks-from-bottom',
    selector: '.mask-from-bottom span',
    duration: 1,
    markers: false,
    callback: null
  };

  if (userOptions) {
    options = Object.assign(options, userOptions);
  }

  const wrappers = gsap.utils.toArray(options.wrapper);

  if (wrappers.length) {
    wrappers.forEach(wrapper => {
      const selectors = wrapper.querySelectorAll(options.selector);

      gsap
        .timeline({
          scrollTrigger: {
            trigger: options.wrapper,
            start: "top 70%",
            end: "top 70%",
            toggleActions: "play none reverse none",
            markers: options.markers
          },
        })
        .to(selectors, {
          y: 0,
          opacity: 1,
          stagger: 0.05,
          duration: options.duration,
          onComplete: options.callback,
        });
    });
  }
};

export function textsFromLeft(wrapper = ".texts-from-left", selector = ".text-from-left>*", duration = 1, markers = false) {
  const wrappers = gsap.utils.toArray(wrapper);

  wrappers.forEach(wrapper => {

    const selectors = wrapper.querySelectorAll(selector);

    gsap
      .timeline({
        scrollTrigger: {
          trigger: wrapper,
          start: "top 70%",
          end: "top 70%",
          toggleActions: "play none reverse none",
          markers: markers
        },
      })
      .to(selectors, {
        x: 0,
        opacity: 1,
        stagger: 0.2,
        duration: duration,
      });
  });
}

export function textsFromBottom(wrapper = ".texts-from-bottom", selector = ".text-from-bottom>*", duration = 1, markers = false) {

  const wrappers = gsap.utils.toArray(wrapper);

  wrappers.forEach(wrapper => {

    const selectors = wrapper.querySelectorAll(selector);

    gsap
      .timeline({
        scrollTrigger: {
          trigger: wrapper,
          start: "top 70%",
          end: "top 70%",
          toggleActions: "play none reverse none",
          markers: markers
        },
      })
      .to(selectors, {
        y: 0,
        opacity: 1,
        stagger: 0.2,
        duration: duration,
      });
  });
}

export function lineHeight(selector, duration = 1) {
  gsap.to(selector, {
    height: '100%',
    duration: duration,
  });
};

export function staggerDisplay(wrapper = ".stagger-display", selector = ".stagger-display>*", duration = 0, markers = false) {
  const wrappers = gsap.utils.toArray(wrapper);

  if (wrappers.length) {
    wrappers.forEach(wrapper => {

      const selectors = wrapper.querySelectorAll(selector);

      gsap
        .timeline({
          scrollTrigger: {
            trigger: wrapper,
            start: "top 70%",
            end: "top 70%",
            toggleActions: "play none reverse none",
            markers: markers
          },
        })
        .to(selectors, {
          opacity: 1,
          stagger: 0.05,
          duration: duration,
        });
    })
  };

};

// EFFECTS
export const effectSwapText = {
  name: "swapText",
  effect: (targets, config) => {
    let tl = gsap.timeline({ delay: config.delay });
    tl.to(targets, { opacity: 0, duration: config.duration / 2 });
    tl.add(() => targets[0].innerText = config.text);
    tl.to(targets, { opacity: 1, duration: config.duration });
    return tl;
  },
  defaults: { duration: 1 },
  extendTimeline: true
}

export const effectCount = {
  name: "count",
  extendTimeline: true,
  defaults: {
    end: 0,
    duration: 0.5,
    ease: "power1",
    increment: 1,
  },
  effect: (targets, config) => {
    let tl = gsap.timeline()
    let num = targets[0].innerText.replace(/\,/g, '')
    targets[0].innerText = num

    tl.to(targets, {
      duration: config.duration,
      innerText: config.end,
      modifiers: {
        innerText: function (innerText) {
          return gsap.utils.snap(config.increment, innerText).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      },
      ease: config.ease
    }, 0)

    return tl
  }
}